import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  customerServiceReview,
  networkReview,
  billReview,
  digitalExperienceReview,
  onboardingExperienceReview,
  ThanksRating,
  // selectCurrentProviderMobile,
  selectCurrentProviderMobileC,
  startRatingMobile,
  confirmReview,
  selectCurrentProviderInternet,
  startRatingInternet,
  nameNickname,
  recommendProviderReviewB,
  finalWordWithReferralCodeReview,
  // finalWordWithReferralCodeReviewC,
  emailAddressReview,
  addressLocationReviews,
  finalWordWithReferralCodeReviewD,
  // addressLocationReviewsC,
} from './reviews-steps'

export const internetReviewsAwardScenarioB: Scenario = {
  id: 'internet-reviews-award-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.INTERNET_REVIEWS_AWARD,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderInternet.id,
    addressLocationReviews.id,
    startRatingInternet.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReview.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderInternet,
    addressLocationReviews,
    startRatingInternet,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReview,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}

export const mobileReviewsAwardScenarioB: Scenario = {
  id: 'mobile-reviews-award-b',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.MOBILE_REVIEWS_AWARD,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderMobileC.id,
    // addressLocationReviews.id,
    startRatingMobile.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReview.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderMobileC,
    // addressLocationReviews,
    startRatingMobile,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReview,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}

export const mobileReviewsAwardScenarioC: Scenario = {
  id: 'mobile-reviews-award-c',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.MOBILE_REVIEWS_AWARD,
  version: '1',
  milestones: [
    emailAddressReview.id,
    nameNickname.id,
    selectCurrentProviderMobileC.id,
    startRatingMobile.id,
    customerServiceReview.id,
    networkReview.id,
    billReview.id,
    digitalExperienceReview.id,
    onboardingExperienceReview.id,
    recommendProviderReviewB.id,
    finalWordWithReferralCodeReviewD.id,
    // addressLocationReviewsC.id,
    confirmReview.id,
    ThanksRating.id,
  ],
  steps: [
    emailAddressReview,
    nameNickname,
    selectCurrentProviderMobileC,
    startRatingMobile,
    customerServiceReview,
    networkReview,
    billReview,
    digitalExperienceReview,
    onboardingExperienceReview,
    recommendProviderReviewB,
    finalWordWithReferralCodeReviewD,
    // addressLocationReviewsC,
    confirmReview,
    ThanksRating,
  ],
  weight: 1,
}
